module.exports = __webpack_public_path__ + "static/media/sinan-bw.3f6173f6.jpg";